/**
 * Product code used to call product_details API for the NIAT program
 * verification (call registration) flow.
 */
export const PROGRAM_VERIFICATION_PRODUCT_CODE =
  'NIAT_VERIFICATION_CALL_REGISTRATION';

/** Form value key that drives the verification T&C `relevantCondition`. */
export const PROGRAM_VERIFICATION_INSTITUTE_NAME_FIELD = 'institute_name';

/**
 * Entity type for the second entity that the backend now ships on the enrollment
 * section. Its `extra_config` carries the `webianr_redirection_url` used to send
 * the user to the verification webinar after the free order is created.
 */
export const PROGRAM_CONSENT_CONFIRMATION_ENTITY_TYPE =
  'PROGRAM_CONSENT_CONFIRMATION';

/**
 * Toggle and values for local verification-flow testing.
 * Set `enabled` to false once the real verification product is wired.
 */
export const PROGRAM_VERIFICATION_MOCK_CONFIG = {
  enabled: false,
  /** Skip treating unrelated paid orders (e.g. admission test) as verification orders. */
  ignoreExistingUserOrders: true,
  /** Skip create-order API in mock mode and redirect directly after modal submit. */
  skipOrderCreation: true,
  redirectUrl: 'https://www.niatindia.com/',
  termsAndConditionsLabel:
    "I understand that my admission is subject to meeting the University's Eligibility Criteria.",
  enrollmentDetailsFallback: {
    studentName: 'S. Surya Anand',
    parentName: 'N Suresh Anand',
    preferredUniversity:
      "St. Peter's Institute of Higher Education and Research",
    preferredBranch: 'B. Tech in AI ML'
  }
} as const;

export const PROGRAM_VERIFICATION_BANNER_TITLE =
  'NIAT Program Verification - ';

export const PROGRAM_VERIFICATION_BANNER_TITLE_MOBILE =
  'NIAT Program Verification';

export const PROGRAM_VERIFICATION_BANNER_DESCRIPTION =
  'This verification covers your program details, fees, and terms.';

export const PROGRAM_VERIFICATION_START_BUTTON_TEXT = 'Start Verification';

export const PROGRAM_VERIFICATION_START_BUTTON_TEXT_MOBILE = 'Start';

export const PROGRAM_VERIFICATION_MODAL_REDIRECT_HINT =
  'Redirects to the webinar portal.';

export const PROGRAM_VERIFICATION_COMPLETED_BADGE_TITLE =
  'NIAT Program Verification';

export const PROGRAM_VERIFICATION_COMPLETED_BADGE_STATUS = 'Completed';

export const PROGRAM_VERIFICATION_COMPLETED_BADGE_NOTE =
  'Completion status recorded on the portal.';
